/// <reference path="../../../../../pizzacorleone/klasik/js/global/types/global.d.ts" />


module PoskiQ {
    "use strict";

    export class OrderCart {
        public static Instance: OrderCart = null;
        private containerClass:string = '.js-cart-container';
        private cartClass:string = '.js-shopping-cart';
        private customerClass:string = '.js-user-container';
        private deliveryPaymentClass:string = '.js-delivery-payment';
        private checkoutClass:string = '.js-checkout-container';
        private bottomActionsClass:string = '.js-bottom-actions';

        private container: JQuery;
        private form: JQuery;
        private spinner: JQuery;
        private recountTimeoutHandle: number;
        public href: string;

        public constructor() {
            this.container = this.findContainerIn($(document.body), this.containerClass);
            this.form = this.container.closest('form');
            this.href = window.location.href;
            this.appendSpinner();
            this.bindRecountOnCountChange();
            this.bindRemoveItem();
            this.bindAddDiscount();
            this.bindRecountOnDiscountCheck()
        }

        private findContainerIn(document: JQuery, $class): JQuery {
            return document.find($class);
        }

        private appendSpinner(): void {
            this.spinner = $('<div class="spinner-holder"><i class="fa fa-spinner fa-spin"></i></div>');
            this.spinner.hide();
            this.container.find(this.cartClass).append(this.spinner);
        }

        private bindRecountOnCountChange(): void {
            $('.product-recount').hide();
            this.container.find(this.cartClass + ' input[data-counter-input]').on('change', function(/*event: JQueryEventObject*/) {
                this.scheduleRecount();
            }.bind(this));
        }

        private scheduleRecount() {
            window.clearTimeout(this.recountTimeoutHandle);
            this.recountTimeoutHandle = window.setTimeout(this.submitForm.bind(this), 200);
        }

        private submitForm(): void {
            var data = this.form.serialize();
            var refreshTimeout = window.setTimeout(function() { // zachranne odeslani
                this.form.submit();
            }.bind(this), 10000);

            this.spinner.show();
            $.post(this.href, data, function(data/*, textStatus, jqXHR*/) {
                window.clearTimeout(refreshTimeout);

                var newCart = this.findContainerIn($(data), this.cartClass);
                this.container.find(this.cartClass).html(newCart.html());

                var newDeliveryPayment = this.findContainerIn($(data), this.deliveryPaymentClass);
                this.container.find(this.deliveryPaymentClass).html(newDeliveryPayment.html());

                var newCustomer = this.findContainerIn($(data), this.customerClass);
                this.container.find(this.customerClass).html(newCustomer.html());

                var newCheckout = this.findContainerIn($(data), this.checkoutClass);
                this.container.find(this.checkoutClass).html(newCheckout.html());

                var newBottomActions = this.findContainerIn($(data), this.bottomActionsClass);
                this.container.find(this.bottomActionsClass).html(newBottomActions.html());

                sumPanel($('[data-amount-input]')); ////////
                OrderCart.Instance = new OrderCart(); // resetovani stranky, navazani udalosti
            }.bind(this));
        }

        private bindAddDiscount(): void {
            this.container.find(this.cartClass + ' .js-submit-discount').on('click', function(event: JQueryEventObject) {
                this.scheduleRecount();
                event.preventDefault();
            }.bind(this));
        }

        private bindRemoveItem(): void {
            this.container.find(this.cartClass + ' .js-product-remove').on('click', function(event: JQueryEventObject) {
                let  $href = event.currentTarget.getAttribute('href');
                this.href = $href;
                this.submitForm();
                event.preventDefault();
            }.bind(this));
        }

        private bindRecountOnDiscountCheck(): void {
            this.container.find('[name="use-credit"]').on('click', function(){this.scheduleRecount();}.bind(this));
        }
    }

    $(function() {
        if (!document.body.className.match(/location_order_getCart/))
            return;

        OrderCart.Instance = new OrderCart();
    });
}
